import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileManagementService } from 'src/service/profile-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BarCodeCategory, FocusInputType, KeyValueSetInt, LastUsedKey, LastUsedSettingsType, LocalService, NumericConfig, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-barcode-generator',
  templateUrl: './barcode-generator.component.html',
  styleUrls: ['./barcode-generator.component.scss']
})
export class BarcodeGeneratorComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["barcode"]; isQuantityShow: boolean = false; @Input() productId = '0'; @Input() businessId = '0'; @Input() isShowLabelPrint = false;
  value: string = '0'; printWidth: number = 200; @Input() categoryCode: number = BarCodeCategory.General; countryCode: string = '';
  maxBodyHeight = 0; barCodeSize: number = 200; @Input() displayValue = ''; @Input() isGlobalBarcode = true;
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  
  htmlId: string = ''; elementIds: any;

  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private profileManagementService: ProfileManagementService) { 
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      qr_code_save: 'qr_code_save_' + this.htmlId,
      qr_code_print: 'qr_code_print_' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onSetLastUsedSettings();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave(isPrint = false) {
    this.localService.onFocusNextInput(isPrint ? this.elementIds.qr_code_print : this.elementIds.qr_code_save, FocusInputType.Button, true);
    this.onPopupClose();
  }

  onGetBusinessId(): string | undefined {
    let businessId: string | undefined = undefined;
    if (this.businessId && this.businessId != '0')
      businessId = this.businessId;
    else if (this.categoryCode == BarCodeCategory.Business)
      businessId = this.value;
    return businessId;
  }

  onSetLastUsedSettings() {
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.QrPrintSize, this.onGetBusinessId());
    if (temp != '') {
      this.barCodeSize = parseFloat(temp);
    }
  }

  onSaveLastUsedSettings() {
    if (!this.barCodeSize)
      this.barCodeSize = 200;

    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.QrPrintSize, this.onGetBusinessId());
    if (temp != this.barCodeSize.toString())
      items.push({ keyType: LastUsedSettingsType.QrPrintSize, value: this.barCodeSize.toString() } as LastUsedKey);

    if (items.length > 0) {
      if (this.onGetBusinessId()) {
        this.profileManagementService.saveLastUsedSettings(items, this.onGetBusinessId()).subscribe(result => {
        });
      } else {
        this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
        });
      }
    }
  }
}
